module.exports = __webpack_public_path__ + "static/media/youManageLogo.5b62c76d.svg";